import React, { useEffect, useState } from 'react';
import {
    Avatar, Box, Chip, CircularProgress,
    List, ListItem, ListItemAvatar, ListItemText, Typography
} from '@mui/material';
import { useTelegram } from 'hooks/useTelegram';
import StickersService from 'api/stickers/stickers.service';
import { StickerModel } from 'api/stickers/models/sticker.model';

const CollectionPage = () => {
    const { tg } = useTelegram();
    const initData: string = tg.initData;

    const [stickers, setStickers] = useState<StickerModel[]>([]);
    const [popularTags, setPopularTags] = useState<string[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        StickersService.getAll(initData)
            .then(setStickers)
            .finally(() => setLoading(false));

        StickersService.getPopularTags(initData)
            .then(setPopularTags)
            .catch(err => console.error('Failed to load popular tags', err));
    }, [initData]);

    const onTagClick = (tag: string) => {
        tg.switchInlineQuery(tag);
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
            </Box>
        );
    }

    if (stickers.length === 0) {
        return (
            <Box textAlign="center" mt={4}>
                <Typography color="text.secondary">Збережених стікерів немає</Typography>
            </Box>
        );
    }

    return (
        <>
            {popularTags.length > 0 && (
                <Box display="flex" flexWrap="wrap" gap={0.5} p={1.5}>
                    {popularTags.map(tag => (
                        <Chip
                            key={tag}
                            label={`#${tag}`}
                            size="small"
                            clickable
                            onClick={() => onTagClick(tag)}
                        />
                    ))}
                </Box>
            )}
            <List disablePadding>
                {stickers.map(sticker => (
                    <ListItem key={sticker.id} divider alignItems="flex-start">
                        {sticker.hasThumbnail && (
                            <ListItemAvatar>
                                <Avatar
                                    src={StickersService.thumbnailUrl(sticker.id, initData)}
                                    variant="rounded"
                                    sx={{ width: 48, height: 48 }}
                                />
                            </ListItemAvatar>
                        )}
                        <ListItemText
                            primary={
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    {sticker.emoji && <span>{sticker.emoji}</span>}
                                    <Typography variant="body2" color="text.secondary" noWrap>
                                        {sticker.setName ?? sticker.type}
                                    </Typography>
                                </Box>
                            }
                            secondary={
                                <Box display="flex" flexWrap="wrap" gap={0.5} mt={0.5}>
                                    {sticker.tags.map(tag => (
                                        <Chip key={tag} label={`#${tag}`} size="small" />
                                    ))}
                                </Box>
                            }
                        />
                    </ListItem>
                ))}
            </List>
        </>
    );
};

export default CollectionPage;
